import { gradeColor } from "../game/results.js";
export class AcResults extends HTMLElement {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "result", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    set data(r) {
        this.result = r;
        this.render();
    }
    render() {
        const r = this.result;
        if (!r)
            return;
        const gc = gradeColor(r.grade);
        const s = r.stats;
        const landed = s.perfect + s.early + s.late + s.free;
        const attempts = landed + s.miss;
        const accPct = Math.round(r.accuracy * 100);
        const statRow = (label, val, color) => `<div style="display:flex;justify-content:space-between;
                        padding:6px 0;border-bottom:1px solid rgba(255,255,255,.08)">
                       <span style="opacity:.75">${label}</span>
                       <span style="font-weight:700;color:${color}">${val}</span>
                     </div>`;
        const newBest = r.isNewBest
            ? `<div style="margin:10px 0 0;text-align:center;font-weight:900;
                        letter-spacing:.08em;color:#fbbf24;
                        text-shadow:0 0 18px rgba(251,191,36,.6);
                        animation:vpNewBest 1s ease-in-out infinite">
                       ★ NEW BEST! ★</div>`
            : "";
        this.style.position = "absolute";
        this.style.inset = "0";
        this.style.zIndex = "20";
        this.style.pointerEvents = "auto";
        this.innerHTML = `
              <style>
                @keyframes vpGradePop {
                  0%   { transform: scale(.2) rotate(-12deg); opacity:0 }
                  55%  { transform: scale(1.25) rotate(4deg); opacity:1 }
                  100% { transform: scale(1) rotate(0); opacity:1 }
                }
                @keyframes vpRiseR {
                  from { opacity:0; transform: translateY(18px) }
                  to   { opacity:1; transform: translateY(0) }
                }
                @keyframes vpNewBest {
                  0%,100% { transform: scale(1) }
                  50%     { transform: scale(1.08) }
                }
              </style>
              <div style="position:absolute;inset:0;background:
                  radial-gradient(900px 600px at 50% 30%,rgba(34,211,238,.12),
                    rgba(8,10,22,.92)),rgba(8,10,22,.9);
                  display:flex;align-items:center;justify-content:center">
                <div style="background:#0d1024;border:1px solid #2a2f4a;
                    border-radius:20px;width:min(92vw,460px);color:#fff;
                    padding:28px 26px;box-shadow:0 24px 80px rgba(0,0,0,.6)">
                  <div style="text-align:center">
                    <div style="font-size:12px;letter-spacing:.18em;
                        text-transform:uppercase;opacity:.6">Results</div>
                    <div style="font-size:120px;font-weight:900;line-height:1;
                        color:${gc};text-shadow:0 0 44px ${gc}88;
                        animation:vpGradePop .6s cubic-bezier(.2,.8,.2,1) both">
                      ${r.grade}</div>
                    ${newBest}
                  </div>
                  <div style="margin:18px 0 0;animation:vpRiseR .5s ease .25s both">
                    <div style="display:flex;justify-content:space-between;
                        align-items:baseline;margin-bottom:8px">
                      <span style="font-size:15px;opacity:.7">Score</span>
                      <span style="font-size:30px;font-weight:900">${r.score}</span>
                    </div>
                    <div style="display:flex;justify-content:space-between;
                        font-size:12px;opacity:.6;margin-bottom:12px">
                      <span>Accuracy ${accPct}% (${landed}/${attempts})</span>
                      <span>Best combo ${r.bestCombo}x</span>
                    </div>
                    ${statRow("Perfect", String(s.perfect), "#4ade80")}
                    ${statRow("Early", String(s.early), "#fbbf24")}
                    ${statRow("Late", String(s.late), "#fb923c")}
                    ${statRow("Nice (untimed)", String(s.free), "#22d3ee")}
                    ${statRow("Miss", String(s.miss), "#f87171")}
                    ${statRow("Sustains held", String(s.sustainsHeld), "#a78bfa")}
                  </div>
                  <div style="margin:14px 0 0;padding-top:12px;
                      border-top:1px solid rgba(255,255,255,.1);
                      font-size:12px;opacity:.7;text-align:center;
                      animation:vpRiseR .5s ease .35s both">
                    High score <b style="color:#fff">${r.best.bestScore}</b>
                    &nbsp;·&nbsp; Best combo <b style="color:#fff">${r.best.bestCombo}x</b>
                    &nbsp;·&nbsp; Runs <b style="color:#fff">${r.best.runs}</b>
                  </div>
                  <div style="display:flex;gap:10px;margin-top:20px;
                      animation:vpRiseR .5s ease .45s both">
                    <button data-again style="pointer-events:auto;cursor:pointer;
                        flex:1;padding:14px;border-radius:14px;border:none;
                        background:linear-gradient(120deg,#22d3ee,#4ade80);
                        color:#0a0d1c;font-size:16px;font-weight:800">
                      ▶ Play again</button>
                    <button data-quit style="pointer-events:auto;cursor:pointer;
                        padding:14px 18px;border-radius:14px;
                        border:1px solid #2a2f4a;background:#1a1f3a;color:#fff;
                        font-size:15px;font-weight:700">Done</button>
                  </div>
                </div>
              </div>`;
        this.querySelector("[data-again]")?.addEventListener("click", () => {
            this.dispatchEvent(new CustomEvent("results-again", { bubbles: true }));
        });
        this.querySelector("[data-quit]")?.addEventListener("click", () => {
            this.dispatchEvent(new CustomEvent("results-quit", { bubbles: true }));
        });
    }
}
customElements.define("ac-results", AcResults);
